import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import * as React from "react";
import { cn } from "~/lib/utils.ts";

import { Button } from "./button";
import { Calendar } from "./calendar";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "./popover";

// type Props = React.ComponentProps<typeof Calendar>;
type Props = React.ComponentProps<typeof Calendar> & {
  open: boolean;
  onToggle: () => void;
};
export function DatePicker(props: Props): JSX.Element {
  return (
    <Popover
    // open={props.open}
    >
      <PopoverTrigger asChild>
        <Button
          // onClick={() => props.onToggle()}
          className={cn(
            "h-10 w-full justify-between border-gray-300 px-3 py-2.5 text-left font-normal focus:border-secondary-500 focus:ring-1 focus:ring-secondary-500",
            !props.selected && "text-muted-foreground",
            props.className,
          )}
          size="sm"
          variant="outline"
        >
          <div
            className={cn(
              "text-sm",
              props.selected ? "text-primary-500" : "text-muted-foreground",
            )}
          >
            {props.selected ? (
              format(new Date(props.selected as unknown as string), "PPP")
            ) : (
              <span>Pick a date</span>
            )}
          </div>
          <CalendarIcon className="mr-0 h-4 w-4 text-primary-500" size={20} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        onWheel={(event) => event.stopPropagation()}
        side="bottom"
        align="end"
        className="my-2 w-fit rounded-2xl p-0"
      >
        <Calendar
          captionLayout="dropdown-buttons"
          fromYear={1900}
          initialFocus
          {...props}
        />
        <div className="px-3">
          <hr className="" />
        </div>
        <div className="flex gap-3 p-5">
          <PopoverClose>
            <Button
              // onClick={() => props.onToggle()}
              className="flex-grow"
              variant="outline"
            >
              Cancel
            </Button>
          </PopoverClose>
          <PopoverClose>
            <Button
              // onClick={() => props.onToggle()}
              className="flex-grow"
            >
              Apply
            </Button>
          </PopoverClose>
        </div>
      </PopoverContent>
    </Popover>
  );
}
